import { TwainGameId } from 'betgames-contract-js';
import { TranslationProvider as SharedMonoTranslationProvider } from 'twain-sport-fe-mono';
import { ITranslationsResponse, ITranslate } from 'store/Translations/interfaces';
import TranslationsRepository from './Translations.repository';

export default class TranslationsStore {
    private translate: ITranslate;

    private createTranslations = (translations: ITranslationsResponse): void => {
        this.translate = {
            string: (key: string) => {
                const { string } = translations;

                return string && string[key] ? string[key] : key;
            },

            stringByGame: (key: string, gameId?: TwainGameId) => {
                const { stringByGame } = translations;

                return stringByGame?.[gameId]?.[key] ?? this.translate.string(key);
            },

            error: (key: string) => {
                const { error } = translations;

                return error && error[key] ? error[key] : key;
            },

            gameName: (id: number) => {
                const { gameNames } = translations;

                return gameNames && gameNames[id] ? gameNames[id] : `Game_${id}`;
            },

            dates: (key: string) => {
                const { dates } = translations;

                return dates && dates[key] ? dates[key] : key;
            },

            bettingOption: (gameId: TwainGameId, id: string) => {
                const { bettingOption } = translations;

                return bettingOption[gameId] && bettingOption[gameId][id]
                    ? bettingOption[gameId][id]
                    : id;
            },

            bettingOptionDetails: (key: string) => {
                const { bettingOption } = translations;
                return bettingOption && bettingOption.details && bettingOption.details[key]
                    ? bettingOption.details[key]
                    : key;
            },

            bettingOptionGroup: (gameId: TwainGameId, id: string) => {
                const { bettingOptionGroup } = translations;

                return bettingOptionGroup[gameId] && bettingOptionGroup[gameId][id]
                    ? bettingOptionGroup[gameId][id]
                    : id;
            },

            groupNames: (key: string) => {
                const { groupNames } = translations;

                return groupNames && groupNames[key] ? groupNames[key] : key;
            },
        };
    };

    constructor(
        private readonly repository: TranslationsRepository,
        private readonly monotranslationStore: SharedMonoTranslationProvider,
    ) {}

    public init = (): Promise<void> =>
        this.repository.fetch().then((data) => {
            this.createTranslations(data);
            this.monotranslationStore.set(data);
        });

    public useTranslate = (): ITranslate => this.translate;
}
